import React from "react";

function Header({ currentAircraft }) {
  return (
    <header className="App-header_router">
      <h1>{currentAircraft.tailNumber || "Select Aircraft on homepage"}</h1>

      <p>Take-Off and Landing Data-Card</p>

      {/* show image only if an aircraft imageUrl exists */}
      {currentAircraft.imageUrl && (
        <img
          className="App-logo"
          src={currentAircraft.imageUrl}
          alt=""
        />
      )}

      <p className="offset-text-header1">
        {currentAircraft.makeModel || ""}
        {currentAircraft.engine
          ? ` - (${currentAircraft.engine})`
          : ""}
      </p>

      <p className="companion-app-notice">
        Companion site to the mobile ToldCardApp —{" "}
        <a href="/privacy#mobile-app">Privacy Policy</a>
      </p>
      
      <p className="companion-app-notice">
        revision: v0.1.16
      </p>
    </header>
  );
}

export default Header;